import React from "react"
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Header from "./Header";
import Footer from "./Footer";

const styles = theme => ({
  root: {
    textAlign: 'center',
  },
  innerRoot: {
    margin: '0 auto',
    flexGrow: 1,
    maxWidth: 1200,
    padding: 15,
    paddingTop: 25,
  },
  menu: {
    float: 'right',
    paddingRight: '6px',
  },
  body: {
    maxWidth: 1200,
    margin: '0 auto',
    textAlign: 'center',
  }
});

class Layout extends React.Component {

  render() {
    const { classes, children, scripts, showHeader, hero } = this.props;

    return (
      <Grid container className={classes.root}>
        <Header scripts={scripts} showHeader={showHeader} hero={hero} />
        <Grid container item
          className={classes.innerRoot}
        >
          <Grid container item md={12}
            className={classes.body}
            justify="center"
            alignItems="center">
            {children}
          </Grid>
        </Grid>
        <Footer />
      </Grid>
    )
  }
}

Layout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout)
